import PropTypes from 'prop-types';
import React, {Component} from 'react';
//import get from 'lodash/get';
//import classNames from 'classnames';
import css from './css.css';
// import VFlexPropagate from "~/components/VFlexPropagate";
import {VFlexPropagate} from "~/native-ui";

export default class MapPage extends Component {
    static propTypes = {};

    render() {
        return (
            <VFlexPropagate full>
                <iframe className={css.mapFrame} src="http://www.gmapgis.com/viewer.htm?LBIcb8Trnl.gmp" />
            </VFlexPropagate>
        );
    }
}